import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';

@Component({
    selector: 'app-signature-pad',
    templateUrl: './signature-pad.component.html',
    standalone: false
})
export class SignaturePadComponent {
  signatureNeeded!: boolean;
  signaturePad!: SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  signatureImg!: string;

  constructor(private dialogRef: MatDialogRef<SignaturePadComponent>) {
    this.dialogRef.disableClose = true;
    this.dialogRef.updateSize('764px', 'auto');
  }

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    this.handleSignatureCanvasSize();
  }

  clearPad() {
    this.signaturePad.clear();
  }

  savePad() {
    const base64Data = this.signaturePad.toDataURL();
    this.signatureImg = base64Data;
    this.signatureNeeded = this.signaturePad.isEmpty();
    if (!this.signatureNeeded) {
      this.signatureNeeded = false;
      this.dialogRef.close(this.signatureImg);      
    }
  }

  closePad(){
    this.dialogRef.close()
  }

  handleSignatureCanvasSize() {
    const canvas = this.canvasEl.nativeElement;
    const container = canvas.parentElement;
    
    if (container) {
      const canvasWidth = container.clientWidth;
      canvas.width = canvasWidth - 48;
      canvas.height = 200;
    }
    this.signaturePad.clear();
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.handleSignatureCanvasSize(); //handle the resizing of signature pad canvas on resizing screen
  }
}
